const amrcLogo = '';
const ewiraBracketImage = '';
const gknLogo = '';
const heroPoster = '';
const heroScan = '';
const ministryOfDefenceLogo = '';
const renishawLogo = '';
const robotCloseup = '';
const brandLogoGreenAsset = '';

// Prefer CDN-hosted product media when it is configured, but keep local fallbacks during the migration.
const mediaCdnBaseUrl = process.env.REACT_APP_MEDIA_CDN_BASE_URL || 'https://d8xhyovu00185.cloudfront.net';

function buildCdnAssetUrl(filename) {
  if (!mediaCdnBaseUrl || !filename) {
    return '';
  }

  const normalizedBase = mediaCdnBaseUrl.replace(/\/$/, '');
  const encodedPath = filename
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');

  return `${normalizedBase}/${encodedPath}`;
}

function assetOrFallback(filename, fallback) {
  return buildCdnAssetUrl(filename) || fallback;
}

const rivelinLogo = brandLogoGreenAsset;
const heroCenterLogo = 'https://images.ctfassets.net/bjia12x471fb/21fBJzMp8S1LOhqD1y1l2N/f5f6314d7ec6c2da38317f8dbad37800/rivelin_logo-idevice_gr-lgt_4x.png';
const r1000Render = assetOrFallback('r1000_Render.png', robotCloseup);
const r1000RefreshedRender = `${mediaCdnBaseUrl}/r1000.png`;
const r1000TeamPhoto = assetOrFallback('Riv_r1000-A-CVG-1-Team_2026-03-15_vA.JPG', r1000Render);
const netShapeFamily = assetOrFallback('NetShape_Family_1100x401px_72ppi.png', heroScan);
const r500WaitlistMedia = '/r500/r500-render.png';
const roboticRoofModuleMedia = buildCdnAssetUrl('Slider-Bilder_AT800_Robotic.png');
const productAnimation = assetOrFallback('Product Animations_sm_sh.gif', netShapeFamily);
const r1000ModuleA = '/modules/r1000_Render-m1000-A.png';
const r1000ModuleB = '/modules/r1000_Render-m1000-B.png';
const r1000ModuleC = '/modules/r1000_Render-m1000-C.png';
const salesVideo = buildCdnAssetUrl('Riv_r1000-CVG-Sales_2026-03-23.mp4');
const robotScanVideo = buildCdnAssetUrl('Robot-Scan_Rivelin.mp4');
const robotShavingVideo = buildCdnAssetUrl('Robot-Shaving-part_Rivelin.mp4');
const robotTrimmingVideo = buildCdnAssetUrl('Robot-trimming-part_Rivelin.mp4');
const angleGrinderVideo = buildCdnAssetUrl('Angle-Grinder_Rivelin.mp4');
const softwareControlVideo = buildCdnAssetUrl('Software-Controlling-robot_Rivelin.mp4');
const toolReturnVideo = buildCdnAssetUrl('Tool-Return_Rivelin.mp4');

export const fallbackSiteContent = {
  siteSettings: {
    siteName: 'Rivelin Robotics',
    siteUrl: 'https://www.rivelinrobotics.com',
    defaultSeoImage: r1000Render,
    brand: {
      logo: rivelinLogo,
    },
    search: {
      algoliaAppId: process.env.REACT_APP_ALGOLIA_APP_ID || '',
      algoliaApiSearchKey: process.env.REACT_APP_ALGOLIA_API_SEARCH_KEY || '',
      algoliaSiteId: process.env.REACT_APP_ALGOLIA_SITE_ID || '',
      algoliaGitBranch: process.env.REACT_APP_ALGOLIA_GIT_BRANCH || '',
      placeholder: 'Search Rivelin',
      shortcuts: [
        { label: 'Products', href: '/products' },
        { label: 'r1000', href: '/products/r1000' },
        { label: 'r500', href: '/products/r500' },
        { label: 'Robotic Roof Module', href: '/products/robotic-roof-module' },
        { label: 'Case studies', href: '/case-studies' },
        { label: 'Our Story', href: '/our-story' },
        { label: 'FAQ', href: '/faq' },
      ],
    },
    navigation: [],
    utilityNavigation: [],
    careersMenu: [
      { label: 'Careers', href: '/careers', detail: 'Mission, team, and open roles' },
    ],
    contact: {
      email: 'info@rivelinrobotics.com',
      phone: '+44 114 700 3984',
      address: 'Unit 3, Neepsend Triangle, 1 Burton Rd, Sheffield, S3 8BW',
      mapUrl: 'https://maps.google.com/?q=Unit+3+Neepsend+Triangle+1+Burton+Rd+Sheffield+S3+8BW',
      mapEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2379.345323479809!2d-1.4748807837945668!3d53.390762379083974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487191c01b21528b%3A0x8f86dbb89ffcadbf!2sRivelin%20Robotics!5e0!3m2!1sen!2suk!4v1662367364362!5m2!1sen!2suk',
      socials: [
        { label: 'LinkedIn', href: 'https://www.linkedin.com/company/rivelin-robotics' },
        { label: 'YouTube', href: 'https://www.youtube.com/channel/UCxc8MtmIqAeZ7yV3PDfmRIw' },
      ],
    },
    footer: {
      summary: '',
      links: [
        { label: 'Products', href: '/products' },
        { label: 'Technology', href: '/technologies' },
        { label: 'Case Studies', href: '/case-studies' },
        { label: 'Our Story', href: '/our-story' },
        { label: 'Leadership', href: '/leadership' },
        { label: 'Careers', href: '/careers' },
        { label: 'FAQ', href: '/faq' },
      ],
      legalLinks: [
        { label: 'Privacy Policy', href: '/privacy-policy' },
      ],
      legalNote: 'Post Processing Micro Factory.',
    },
  },
  collections: {
    privacyPolicyContent: null,
    proofPoints: [
      {
        value: '5x',
        label: 'productive hours',
        detail: 'Compared to manual.',
      },
      {
        value: '1/5',
        label: 'cost of poor quality',
        detail: 'Compared to manual.',
      },
      {
        value: '0.25',
        label: 'cost of cash',
        detail: 'E.g. labour, energy, training.',
      },
      {
        value: '85%',
        label: '$/kg cost reduction',
        detail: 'Aluminium and Cobalt-Chrome datasets.',
      },
    ],
    partnerOrganizations: [
      {
        slug: 'amrc',
        name: 'AMRC',
        logo: amrcLogo,
        href: 'https://www.amrc.co.uk',
        approvedForPublic: true,
      },
      {
        slug: 'gkn',
        name: 'GKN',
        logo: gknLogo,
        href: 'https://www.gkn.com',
        approvedForPublic: true,
      },
      {
        slug: 'renishaw',
        name: 'Renishaw',
        logo: renishawLogo,
        href: 'https://www.renishaw.com',
        approvedForPublic: true,
      },
      {
        slug: 'ministry-of-defence',
        name: 'Ministry of Defence',
        logo: ministryOfDefenceLogo,
        href: 'https://www.gov.uk/government/organisations/ministry-of-defence',
        approvedForPublic: true,
      },
    ],
    teamMembers: [
    ],
    faqItems: [],
    jobs: [
    ],
    caseStudies: [
      {
        slug: 'titanium-aerospace-bracket-finishing',
        title: 'Titanium aerospace bracket: from 4-hour manual finish to 22-minute automated cycle',
        keywords: ['Aerospace', 'Titanium'],
        date: '2026-04-15',
        publishedAt: '2026-04-15',
        description:
          'A Tier-1 aerospace supplier replaced a four-person hand-finishing team with a single r1000 microfactory. Cycle time dropped from over four hours to 22 minutes, with zero dimensional escapes across the first 300 production parts.',
        summary:
          'A Tier-1 aerospace supplier replaced a four-person hand-finishing team with a single r1000 microfactory. Cycle time dropped from over four hours to 22 minutes, with zero dimensional escapes across the first 300 production parts.',
        featuredImage: '',
        heroImage: '',
        body: '',
        videoUrl: '',
        sector: 'Aerospace',
      },
    ],
    resourceArticles: [
      {
        slug: 'why-post-processing-blocks-metal-am-scale',
        title: 'Why post-processing is still blocking metal AM scale-up',
        category: 'Insight',
        publishedAt: '2026-03-04',
        featuredImage: heroScan,
        summary:
          'Metal AM has matured quickly, but downstream finishing, support removal, and powder handling still hold back repeatable industrial adoption.',
        body: `Manufacturers do not struggle to imagine the value of metal additive manufacturing. The harder question is how to industrialise the steps that happen immediately after printing.\n\nWhen support removal, surface preparation, and finishing remain manual, part quality can drift from operator to operator and site to site. That makes production lines harder to validate, throughput harder to forecast, and investor confidence harder to earn.\n\nRivelin's position is that post-processing should behave like the rest of a modern production system: measurable, repeatable, and backed by a deployment model that protects uptime.\n\nThat is why the combination of adaptive scanning, finishing-aware force control, and guided deployment matters. It moves automation away from one-off demos and towards reliable production behaviour.`,
      },
      {
        slug: 'what-risk-reduced-robotic-deployment-looks-like',
        title: 'What risk-reduced robotic deployment actually looks like',
        category: 'Operations',
        publishedAt: '2026-02-11',
        featuredImage: heroPoster,
        summary:
          'A rollout is not just about installing a microfactory. The real work is protecting production confidence from investigation through acceptance and service.',
        body: `In industrial automation, customer trust is won long before a machine is considered business-as-usual. Deployment planning has to cover trials, acceptance, commissioning, and support with the same care as the technology itself.\n\nRivelin frames this around NPI, pre-production trials, FAT, SAT, in-production support, and preventative maintenance. That sequence matters because each stage reduces uncertainty for a different stakeholder.\n\nOperators need confidence that the system will be usable. Manufacturing leaders need confidence that it will be reliable. Investors need confidence that the company can scale deployment without introducing chaos.\n\nA risk-reduced deployment model turns technical performance into commercial credibility.`,
      },
    ],
    layoutImages: [
      { label: 'r1000', image: `${process.env.PUBLIC_URL || ''}/layout/r1000.png`, contentType: 'image/png' },
    ],
    testimonials: [],
  },
  pages: {
    home: {
      path: '/',
      seo: {
        title: 'Post Processing Micro Factory',
        description:
          'Rivelin Robotics helps manufacturers scan, trim, and finish metal AM parts with a compact robotic workflow and clearer industrial proof.',
      },
      hero: {
        variant: 'cinematicMinimal',
        eyebrow: 'Robotic post-processing',
        title: 'Scan. Trim. Finish.',
        body: 'Post Processing Micro Factory.',
        logo: heroCenterLogo,
        logoAlt: 'Rivelin Robotics',
        partnerLabel: 'Trusted by industry leading organisations',
        partnerLogosInHero: true,
        primaryAction: { label: 'Book a demo', href: '/request-demo' },
        secondaryAction: { label: 'See proof', href: '/case-studies' },
        media: {
          type: 'image',
          src: r1000Render,
          alt: 'r1000 robot render.',
        },
        capabilityReel: [
          {
            eyebrow: 'Scan',
            title: 'Robot scans the real part',
            statement: 'True geometry is read before the process begins.',
            media: robotScanVideo
              ? {
                  type: 'video',
                  src: robotScanVideo,
                  poster: r1000Render,
                  alt: 'Robot scan sequence.',
                }
              : {
                  type: 'image',
                  src: heroScan,
                  alt: 'Robot scanning a metal AM part.',
                },
          },
          {
            eyebrow: 'Cut',
            title: 'Robot cuts the part',
            statement: 'Supports and excess material are removed in a controlled pass.',
            media: robotTrimmingVideo
              ? {
                  type: 'video',
                  src: robotTrimmingVideo,
                  poster: r1000Render,
                  alt: 'Robot cutting sequence.',
                }
              : {
                  type: 'image',
                  src: productAnimation,
                  alt: 'Animated cutting sequence.',
                },
          },
          {
            eyebrow: 'Polish',
            title: 'Robot polishes key surfaces',
            statement: 'Material is removed where it matters, with tighter control than manual handling.',
            media: robotShavingVideo
              ? {
                  type: 'video',
                  src: robotShavingVideo,
                  poster: r1000Render,
                  alt: 'Robot polishing sequence.',
                }
              : {
                  type: 'image',
                  src: robotCloseup,
                  alt: 'Robot polishing hardware close-up.',
                },
          },
          {
            eyebrow: 'Grind',
            title: 'Angle grinding finishes the cycle',
            statement: 'Finishing stays in-cell instead of returning to a manual bottleneck.',
            media: angleGrinderVideo
              ? {
                  type: 'video',
                  src: angleGrinderVideo,
                  poster: r1000Render,
                  alt: 'Angle grinding sequence.',
                }
              : {
                  type: 'image',
                  src: heroPoster,
                  alt: 'Angle grinding sequence.',
                },
          },
          {
            eyebrow: 'Control',
            title: 'Software directs the robot',
            statement: 'The software stack manages path, tool, and process handoff in one system.',
            duration: 11000,
            media: softwareControlVideo
              ? {
                  type: 'video',
                  src: softwareControlVideo,
                  poster: r1000Render,
                  alt: 'Software controlling the robot.',
                }
              : {
                  type: 'image',
                  src: netShapeFamily,
                  alt: 'NetShape product family graphic.',
                },
          },
          {
            eyebrow: 'Change',
            title: 'Tool change closes the cycle',
            statement: 'The cell resets cleanly for the next part.',
            media: toolReturnVideo
              ? {
                  type: 'video',
                  src: toolReturnVideo,
                  poster: r1000Render,
                  alt: 'Tool return sequence.',
                }
              : {
                  type: 'image',
                  src: r1000Render,
                  alt: '3D render of the r1000 microfactory.',
                },
          },
        ],
      },
      sections: [
        {
          type: 'partnerMarquee',
          theme: 'plain',
          collection: 'partnerOrganizations',
        },
        {
          type: 'mediaSpotlight',
          theme: 'soft',
          eyebrow: 'Satisfied clients',
          title: 'Clients made more efficient with\nthe r1000',
          body: 'The r1000 packages adaptive scanning, finishing intelligence, and a cleaner operator experience into one compact system.',
          media: {
            type: 'image',
            src: r1000TeamPhoto,
            alt: 'Rivelin team with the r1000 robot.',
          },
          actions: [
            { label: 'Explore products', href: '/products' },
            { label: 'Explore r1000', href: '/products/r1000' },
          ],
          pills: ['Adaptive scanning', 'Toolpath control', 'Compact deployment'],
        },
        {
          type: 'ctaBanner',
          variant: 'minimal',
          primaryAction: { label: 'Book a Demo', href: '/request-demo' },
        },
        {
          type: 'dualVideo',
          collection: 'r1000HomeDualVideo',
        },
        {
          type: 'statBand',
          theme: 'plain',
          title: 'Production language, not brochure language.',
          collection: 'proofPoints',
        },
      ],
    },
    solutions: {
      path: '/products',
      seo: {
        title: 'Explore Rivelin products',
        description:
          'Compare the r1000 production microfactory and the upcoming r500 early-access route for robotic metal AM post-processing.',
      },
      hero: {
        
        title: 'Explore products',
        body: 'Choose the Rivelin product route that fits your production stage.',
        primaryAction: { label: 'Explore r1000', href: '/products/r1000' },
        secondaryAction: { label: 'Request Early Access', href: '/products/r500' },
        media: { type: 'image', src: r1000RefreshedRender, alt: '3D render of the r1000 microfactory.' },
      },
      sections: [
        {
          type: 'productChooser',
          anchorId: 'product-routes',
          eyebrow: 'Product routes',
          items: [
            {
              eyebrow: 'Available product',
              title: 'r1000',
              body: 'Adaptive scanning, toolpath control, and finishing intelligence in one compact production microfactory.',
              href: '/products/r1000',
              actionLabel: 'Explore r1000',
              media: {
                type: 'image',
                src: r1000RefreshedRender,
                alt: '3D render of the r1000 microfactory.',
              },
              tags: ['Production microfactory', 'Adaptive finishing'],
            },
            {
              eyebrow: 'Upcoming product',
              title: 'r500',
              body: 'The compact route. Same NetShape® intelligence in a smaller footprint. Request Early Access.',
              href: '/products/r500',
              actionLabel: 'Request Early Access',
              media: {
                type: 'image',
                src: r500WaitlistMedia,
                alt: '3D render of the r500 microfactory.',
              },
              tags: ['Early access', 'Early access'],
            },
          ],
        },
      ],
    },
    r1000Product: {
      path: '/solutions/r1000',
      seo: {
        title: 'r1000 robotic post-processing microfactory',
        description:
          'Meet the r1000 product landing page for adaptive support removal, targeted finishing, deployment support, and production post-processing.',
      },
      hero: {
        title: 'r1000',
        body: 'Adaptive scanning, toolpath control, and finishing intelligence in one compact production microfactory.',
        primaryAction: { label: 'Book a demo', href: '/request-demo' },
        secondaryAction: { label: 'Explore all products', href: '/products' },
        media: { type: 'image', src: r1000RefreshedRender, alt: '3D render of the r1000 microfactory.' },
        stats: [
          { number: 5, suffix: 'x', label: 'Productive hours', detail: 'Compared to manual.' },
          { value: '1/5', label: 'Cost of poor quality', detail: 'Compared to manual.' },
          { value: '0.25', label: 'Cost of cash', detail: 'E.g. labour, energy, training.' },
          { number: 85, suffix: '%', label: '$/kg cost reduction', detail: 'Aluminium and Cobalt-Chrome datasets.' },
        ],
      },
      sections: [
        {
          type: 'renderShowcase',
          anchorId: 'meet-r1000',
          title: 'Meet the r1000',
          body: 'Adaptive scanning, toolpath control, and finishing intelligence in one compact production microfactory.',
          media: {
            type: 'image',
            src: r1000RefreshedRender,
            alt: '3D render of the r1000 microfactory.',
          },
          actions: [
            { label: 'Book a demo', href: '/request-demo' },
            { label: 'Explore all products', href: '/products' },
          ],
        },
        {
          type: 'mediaSpotlight',
          eyebrow: 'Product video',
          title: 'See the r1000 in motion.',
          body:
            'See how the r1000 combines scanning, path planning, tooling, and finishing into a single production workflow.',
          media: {
            type: salesVideo ? 'video' : 'image',
            src: salesVideo || robotCloseup,
            poster: r1000Render,
            alt: 'r1000 finishing and deployment sequence.',
          },
          actions: [
            { label: 'Book a demo', href: '/request-demo' },
          ],
          pills: ['Scan', 'Plan', 'Finish', 'Reset'],
          invert: true,
        },
        {
          type: 'specTable',
          eyebrow: 'Technical specification',
          title: 'r1000 specs.',
          groups: [
            {
              label: 'Envelope & payload',
              items: [
                { key: 'Work envelope', value: 'Ø1000 mm × 800 mm H' },
                { key: 'Part payload', value: '400 kg' },
              ],
            },
            {
              label: 'Tooling',
              items: [
                { key: 'End effector docks', value: 'Up to 10' },
                { key: 'Spindle tools', value: '56' },
                { key: 'Processes', value: 'Hammering, chiselling, cutting, nipping, milling, grinding, sanding, polishing, drilling, gripping, 3D scanning, measuring, air-blasting, engraving' },
              ],
            },
            {
              label: 'Supply',
              items: [
                { key: 'Microfactory', value: '400/480V AC 50/60 Hz 32A' },
                { key: 'Dust extraction', value: '400/480V AC 50/60 Hz 16A' },
              ],
            },
            {
              label: 'Pneumatics',
              items: [
                { key: 'Air quality', value: 'Clean, dried. ISO 8573-1 Class 3' },
                { key: 'Min pressure', value: '7 Bar (101 PSI)' },
                { key: 'Max pressure', value: '10 Bar (145 PSI)' },
                { key: 'Peak flow', value: '60 CFM (1700 l/min)' },
              ],
            },
          ],
          layout: {
            items: [
              { key: 'r1000 Cell', value: '4,145 kg — 2.85 × 2.5 × 2.3 m' },
              { key: 'Custom Module (conveyor)', value: '800 kg — 3.2 × 2.3 × 0.6 m' },
              { key: 'Vacuum Cleaner', value: '250 kg — 2.55 × 1.35 × 0.88 m' },
            ],
          },
        },
        {
          type: 'moduleShowcase',
          eyebrow: 'Custom Module',
          title: 'Extend the r1000 your way.',
          body: 'Custom automation modules let you integrate the r1000 into your existing production line or add processing capability beyond the core microfactory. Work with the Rivelin team to configure the right combination for your environment.',
          crossfade: true,
          modules: [
            {
              label: 'm1000-A',
              image: r1000ModuleA,
              alt: 'r1000 m1000-A automation module.',
              body: 'Automated component loading and unloading via robot pick and place for parts up to 100mm diameter. Integrated fixture changing and raised loading area for operator efficiency. Ideal for small, high-volume components with varied mix.',
            },
            {
              label: 'm1000-B',
              image: r1000ModuleB,
              alt: 'r1000 m1000-B automation module.',
              body: 'Integration module for external robotic loading with a containment-rated, sound-insulated sliding door. Ideal for larger components and production system integration.',
            },
            {
              label: 'm1000-C',
              image: r1000ModuleC,
              alt: 'r1000 m1000-C automation module.',
              body: 'Sound-insulated endcap for when a custom module is not required. Modularity allows fast upgrades to alternative module options in future.',
            },
          ],
        },
        {
          type: 'moduleShowcase',
          eyebrow: 'Tool options',
          title: 'The right tool for the job.',
          body: 'The r1000 supports a broad range of end effectors and tooling configurations. Customise the tool set to match your specific post-processing workflow.',
          visibleCount: 3,
          modules: [
            {
              label: 'Tool option 1',
              image: r1000RefreshedRender,
              alt: 'r1000 tool option 1.',
              body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.',
            },
          ],
        },
        {
          type: 'moduleShowcase',
          eyebrow: 'Toolbit options',
          title: 'Precision toolbits for every surface.',
          body: 'A range of toolbits engineered for the r1000 microfactory. Work with the Rivelin team to select the right combination for your part families and finishing requirements.',
          visibleCount: 3,
          modules: [
            {
              label: 'Toolbit option 1',
              image: r1000RefreshedRender,
              alt: 'r1000 toolbit option 1.',
              body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.',
            },
          ],
        },
        {
          type: 'moduleShowcase',
          eyebrow: 'Accessory options',
          title: 'Accessories to complete your setup.',
          body: 'From zero-point pallets to clamping kits, equip the r1000 with the accessories that streamline your workflow.',
          visibleCount: 3,
          modules: [
            {
              label: 'Accessory option 1',
              image: r1000RefreshedRender,
              alt: 'r1000 accessory option 1.',
              body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.',
            },
          ],
        },
        {
          type: 'mediaSpotlight',
          eyebrow: 'Powered by NetShape®',
          title: 'Autonomous finishing intelligence.',
          body: 'NetShape® scans each part, adapts to its real geometry, and drives finishing with robotic precision. The same intelligence runs across every Rivelin platform.',
          actions: [{ label: 'How NetShape works', href: '/technology' }],
        },
      ],
    },
    r500Product: {
      path: '/solutions/r500',
      seo: {
        title: 'r500 compact robotic post-processing microfactory',
        description:
          'Request Early Access to the r500 for updates on a more compact Rivelin microfactory with the same core advantages as the r1000.',
      },
      hero: {
        title: 'r500',
        body: 'Same NetShape intelligence. Smaller footprint.',
        primaryAction: { label: 'Request Early Access', href: '/contact' },
        media: { type: 'image', src: r500WaitlistMedia, alt: '3D render of the r500 microfactory.' },
      },
      sections: [
        {
          type: 'cards',
          columns: 2,
          title: 'A smaller cell with the same core advantages.',
          body: 'For teams that want Rivelin automation where a full r1000 footprint is not practical.',
          items: [
            {
              title: 'Fit tighter spaces',
              body: 'Bring adaptive robotic finishing into production areas where a smaller cell footprint makes deployment easier to place.',
            },
            {
              title: 'Keep the core advantages',
              body: 'Scanning, path planning, force control, and finishing intelligence. The same capabilities proven by the r1000.',
            },
            {
              title: 'Get in early',
              body: 'Share your part families, floor-space limits, and plant context as r500 specifications and launch details open up.',
            },
          ],
        },
        {
          type: 'ctaBanner',
          title: 'Register interest in the r500.',
          body: 'Share your context and the team will follow up as availability and specifications are released.',
          primaryAction: { label: 'Request Early Access', href: '/contact' },
        },
      ],
    },
    roboticRoofModuleProduct: {
      path: '/products/robotic-roof-module',
      seo: {
        title: 'rAD-AT800S — Automated Powder Removal & Finishing | Rivelin',
        description:
          'Rivelin\'s rAD-AT800S integrates into the Solukon SFM-AT800-S to deliver automated powder removal and robotic finishing for complex metal AM parts. Request Early Access.',
      },
      hero: {
        title: 'rAD-AT800S',
        body: 'Automated powder removal and robotic finishing. Fully integrated robotic roof module into the Solukon SFM-AT800-S.',
        primaryAction: { label: 'Request Early Access', href: '/contact' },
        media: { type: 'image', src: roboticRoofModuleMedia, alt: 'rAD-AT800S integrated into the Solukon SFM-AT800-S.' },
      },
      sections: [
        {
          type: 'mediaSpotlight',
          centered: true,
          media: {
            type: 'image',
            src: buildCdnAssetUrl('robotic-roof-module.png'),
            alt: 'rAD-AT800S robotic roof module.',
          },
        },
        {
          type: 'cards',
          columns: 2,
          title: '',
          body: '',
          items: [
            {
              title: 'Robotic powder removal',
              body: 'Compressed air blasting and targeted localised vibration clear powder from complex internal channels and cavities on large metal AM parts.',
            },
            {
              title: 'Channel inspection',
              body: 'Robotic sensing inspects air flow through cleared channels, giving production teams traceable quality data without manual intervention.',
            },
            {
              title: 'Surface enhancement',
              body: 'Media blasting / Air blasting, reciprocating and rotating brushes — integrated into the same automated workflow for consistent surface finish quality.',
            },
            {
              title: 'Get in early',
              body: 'Request Early Access to share your part families, channel geometry, and production context as the rAD-AT800S moves toward commercialisation.',
            },
          ],
        },
        {
          type: 'ctaBanner',
          title: 'Register interest in the rAD-AT800S.',
          body: 'Share your production context and the team will follow up as specifications and availability are confirmed.',
          primaryAction: { label: 'Request Early Access', href: '/contact' },
        },
      ],
    },
    technology: {
      path: '/technology',
      seo: {
        title: 'Adaptive robotics technology for metal AM finishing',
        description:
          'Learn how scanning, path planning, force control, and deployment tooling work together in Rivelin\'s technology stack.',
      },
      hero: {
        title: 'Technology',
        body: 'NetShape®: the software that makes robotic finishing adaptive. Runs on every Rivelin platform.',
        primaryAction: { label: 'Book a demo', href: '/request-demo' },
        media: { type: 'image', src: netShapeFamily, alt: 'NetShape family software and product graphic.' },
      },
      sections: [
        {
          type: 'process',
          eyebrow: 'How NetShape® works',
          title: 'A three-stage system rather than a disconnected toolchain.',
          items: [
            {
              title: 'Scan',
              body: 'Capture each part and establish the real geometry before committing to a finishing path. Proprietary AI snaps the scan to the net shape CAD model.',
            },
            {
              title: 'Adapt',
              body: 'Recognise variability: imprecise parts, fixturing variation, slipping in the chuck. Generate parts, fixturing variation.',
            },
            {
              title: 'Finish',
              body: 'Apply finishing-aware control with standard industrial tools (belt sanders, micro grinders, ultrasonic polishers, nippers, pneumatic hammers) manipulated with robotic precision.',
            },
          ],
        },
        {
          type: 'cards',
          eyebrow: 'Platform capabilities',
          title: 'What makes the system operationally different.',
          body: 'Adaptive planning, force control, and traceability make the microfactory easier to run in production.',
          items: [
            {
              title: 'Adaptive planning',
              body: 'Toolpaths are generated around the real part geometry, not just the ideal CAD file. Every cycle responds to the actual state of the part.',
            },
            {
              title: 'Force control',
              body: 'The system applies consistent finishing force regardless of surface variation, reducing the risk of over- or under-finishing on complex geometries.',
            },
            {
              title: 'Tool wear compensation',
              body: 'NetShape® continuously maps surface topologies and tool wear, adjusting finishing behaviour to maintain consistent output across a production run.',
            },
            {
              title: 'Traceability',
              body: 'Process behaviour is observable and repeatable. Production conversations with customers and regulators become easier when the data exists.',
            },
            {
              title: 'Standard tooling',
              body: 'No proprietary consumables. The system uses standard industrial finishing tools: the same ones your operators already know.',
            },
          ],
        },
        {
          type: 'ctaBanner',
          title: 'Bring your geometry, tolerances, and deployment questions.',
          body: 'One conversation. A straight technical answer.',
          primaryAction: { label: 'Book a demo', href: '/request-demo' },
        },
      ],
    },
    company: {
      path: '/company',
      seo: {
        title: 'Company, mission, traction, and leadership',
        description:
          'Company overview covering mission, market problem, traction, leadership, roadmap, and contact routes.',
      },
      hero: {
        title: 'Rivelin Robotics',
        body: 'Automating the metalworking jobs that are too hazardous, strenuous, or unpleasant to do by hand, accelerating the shift to safer, cleaner digital manufacturing.',
        media: { type: 'image', src: ewiraBracketImage, alt: 'Rivelin company proof visual based on production hardware.' },
      },
      sections: [
        {
          type: 'timeline',
          eyebrow: 'Our story',
          title: 'From Sheffield steel\nto the Swiss Army Robot.',
          items: [
            {
              label: '2018',
              title: 'Founded in the Rivelin Valley',
              body: 'Born from direct experience with the friction between metal AM\'s promise and post-processing reality. Named after the valley where Sheffield\'s toolmaking heritage began.',
              coordinates: '53.3918° N, 1.4742° W',
              image: '/RivelinValley_SheffieldMap_Highlight_1.webp',
              highlights: [
                { type: 'customer', name: 'Bristol Robotics Laboratory', logoKey: 'BRL' },
                { type: 'customer', name: '3T Additive Manufacturing', logoKey: '3T-am' },
              ],
            },
            {
              label: '2020',
              title: 'First NetShape prototype',
              body: 'Early R&D proving that force control, 3D scanning and adaptive toolpaths could automate manual finishing tasks on real AM parts.',
              highlights: [
                { type: 'customer', name: 'Defence & Security Accelerator', logo: 'https://images.ctfassets.net/bjia12x471fb/6p7PgD11nATUFvQVzF1IzZ/a2a93265a69dcc7174146507fced55c8/DSA.png' },
                { type: 'customer', name: 'Renishaw', logoKey: 'renishaw' },
                { type: 'customer', name: 'Innovate UK', logoKey: 'Innovate' },
              ],
            },
            {
              label: '2021',
              title: 'Early customer traction',
              body: 'First commercial engagements proving the technology in production-adjacent environments.',
              highlights: [
                { type: 'customer', name: 'NRC CNRC Canada', logoKey: 'nrc-cnrc' },
                { type: 'customer', name: 'Trinity', logoKey: 'trinity' },
                { type: 'customer', name: 'Creative Destruction Lab', logoKey: 'creative-destruction-lab' },
                { type: 'customer', name: 'Oerlikon', logoKey: 'Oerlikon' },
              ],
            },
            {
              label: '2022',
              title: 'First customer deployments',
              body: 'Production microfactories deployed with aerospace and defence end users for automated support removal and targeted finishing.',
              highlights: [
                { type: 'investor', name: 'Acequia Capital', logoKey: 'acequia' },
              ],
              awards: [
                {
                  title: '3D Printing Industry Startup 2022',
                  image: 'https://images.ctfassets.net/bjia12x471fb/1uNFjKC2RAEBIt1BwDtQah/3338aef1224db1551b086f6abbe76fd3/Award_3DPrintingIndustry_StartUp_2022.png',
                },
                {
                  title: 'Formnext Startup 2022',
                  image: 'https://images.ctfassets.net/bjia12x471fb/4siozant2dedTrmlHH8rXt/c21025d799844f06b73b8ae85a136f02/Award_Formnext_StartUp_2022.png',
                },
              ],
            },
            {
              label: '2023',
              title: 'Defence and aerospace engagement',
              body: 'Engagement with major defence and aerospace organisations for robotic post-processing of mission-critical components.',
              highlights: [
                { type: 'customer', name: 'Royal Air Force', logoKey: 'RAF' },
                { type: 'customer', name: 'British power and propulsion OEM', text: 'British power and propulsion OEM', logoKey: 'rolls-royce' },
              ],
            },
            {
              label: '2024',
              title: 'Major industrial partnerships',
              body: 'Engagement with tier-one energy, aerospace, and medical manufacturers for production-scale post-processing.',
              highlights: [
                { type: 'certification', name: 'Cyber Essentials Plus', logo: 'https://images.ctfassets.net/bjia12x471fb/5yJdtefZgIEg2OnWoKa9tu/8dee65e2e1e5e94a85c07a612fea76d2/cyberEssentials_PLUS.png' },
                { type: 'customer', name: 'Attenborough Medical', logoKey: 'attenborough-medical' },
              ],
            },
            {
              label: '2025',
              title: 'Scaling production deployments',
              body:  'Multiple live cells in North America and the UK. Repeatable delivery proven at scale across powder bed, wire arc and cast parts.',
              highlights: [
                { type: 'customer', name: 'Siemens Energy', logoKey: 'Siemens Energy' },
                { type: 'customer', name: 'GKN Aerospace', logo: 'https://images.ctfassets.net/bjia12x471fb/6BJsmERaBgXY5SCl3bXRmI/3420884ee84407836c05143163656633/gkn.png' },
              ],
            },
            {
              label: '2026',
              title: 'Industrial robotic Swiss-Army knife platform',
              body: 'A flexible microfactory powered by NetShape that can handle multiple post-processing and metalworking tasks in one compact system.',
              highlights: [
                { type: 'customer', name: 'Advanced manufacturing customer', text: 'Advanced manufacturing customer', logoKey: 'confidential' },
                { type: 'customer', name: 'GE Aerospace', logoKey: 'GE-Aerospace' },
                { type: 'customer', name: 'Solukon', logoKey: 'solukon' },
              ],
            },
          ],
        },
        {
          type: 'scrollPrompt',
        },
        {
          type: 'mediaSpotlight',
          eyebrow: 'The team',
          title: 'Exceptional customers supported by an exceptional team.',
          invert: true,
          mediaAspectRatio: 'square',
          media: {
            type: 'image',
            src: 'https://images.ctfassets.net/bjia12x471fb/70g8sdFrCjvNP378MkTXZK/2c125e1081db87e3d91add521a40c4d0/IMG_1292.jpeg',
            alt: 'The Rivelin Robotics team.',
            skipOptimization: true,
          },
          actions: [{ label: 'Meet the team', href: '/leadership' }],
        },
        {
          type: 'scrollPrompt',
        },
        {
          type: 'marketTraction',
          eyebrow: 'Market traction',
          title: 'Where the demand is coming from.',
        },
        {
          type: 'scrollPrompt',
        },
        {
          type: 'ctaBanner',
          eyebrow: 'The vision',
          title: '100 deployments per year by 2030.',
          points: [
            'NetShape as the standard for autonomous post-processing',
            'Platform expansion across North America, EMEA and Japan',
            'r1000 and r500 deployed at scale across aerospace, defence, energy and medical',
          ],
        },
        {
          type: 'ctaBanner',
          variant: 'minimal',
          primaryAction: { label: 'Contact the team', href: '/contact' },
        },
      ],
    },
    careers: {
      path: '/careers',
      seo: {
        title: 'Careers at Rivelin Robotics',
        description:
          'Learn what Rivelin does, where the company is headed, and apply for open roles without downloading a PDF job advert.',
      },
      hero: {
        
        title: 'Careers',
        body: 'Open roles and general applications.',
        primaryAction: { label: 'Jump to open roles', href: '#open-roles' },
        secondaryAction: { label: 'Submit a general application', href: '#job-application' },
        media: { type: 'image', src: heroPoster, alt: 'Rivelin industrial workspace and finishing environment.' },
      },
      sections: [
        {
          type: 'cards',
          eyebrow: 'Why candidates join',
          title: 'Build technology that tells robots what to do.',
          body: 'Intelligent robotics, ML, and data science applied to industry\'s hardest manufacturing problems. A supportive team, a clear mission and enough room to grow.',
          items: [
            {
              eyebrow: 'Mission',
              title: 'Solve a real industrial bottleneck',
              body: 'The work sits at the intersection of robotics, manufacturing, and production-scale problem solving, with direct impact on critical global supply chains.',
            },
            {
              eyebrow: 'Stage',
              title: 'Early enough to shape, mature enough to matter',
              body: 'The product is real, the deployments are live, and the direction is clear. You can see exactly where the company is headed.',
            },
            {
              eyebrow: 'Process',
              title: 'A straightforward application path',
              body: 'Browse open roles below or send a general enquiry directly.',
            },
          ],
        },
      ],
    },
    resources: {
      path: '/resources',
      seo: {
        title: 'Resources and insights',
        description:
          'Browse Rivelin Robotics resources, insight pieces, and explainers.',
      },
      hero: {
        
        title: 'Resources',
        body: 'Articles and explainers.',
        primaryAction: { label: 'Browse articles', href: '#resources-grid' },
        secondaryAction: { label: 'Contact the team', href: '/contact' },
        media: { type: 'image', src: heroScan, alt: 'Resource section hero visual showing a scanned part.' },
      },
      sections: [],
    },
    caseStudies: {
      path: '/case-studies',
      seo: {
        title: 'Case studies and customer proof',
        description:
          'See how Rivelin explains post-processing outcomes, deployment credibility, and operational value through case-study storytelling.',
      },
      hero: {
        eyebrow: 'Case studies',
        title: 'Case studies',
        body: 'Deployment examples and outcomes.',
        primaryAction: { label: 'Book a demo', href: '/request-demo' },
        secondaryAction: { label: 'Explore products', href: '/products' },
        media: { type: 'image', src: ewiraBracketImage, alt: 'Metal AM part highlighted as a case-study visual.' },
      },
      sections: [],
    },
    faq: {
      path: '/faq',
      seo: {
        title: 'Frequently asked questions',
        description:
          'A native FAQ experience that replaces the legacy Adobe PDF embed with searchable, indexable content.',
      },
      hero: {
        title: 'FAQ',
        body: 'Technology, operations, and commercial questions.',
        media: { type: 'image', src: heroPoster, alt: 'FAQ hero with industrial finishing sparks.' },
      },
      sections: [],
    },
    contact: {
      path: '/contact',
      seo: {
        title: 'Contact Rivelin Robotics',
        description:
          'Contact Rivelin Robotics to discuss automated post-processing, deployment planning, partnerships, or investor conversations.',
      },
      hero: {
        
        title: 'Contact',
        body: 'Commercial, technical, and partnership conversations.',
        primaryAction: { label: 'Book a demo instead', href: '/request-demo' },
        secondaryAction: { label: 'Browse case studies', href: '/case-studies' },
        media: { type: 'image', src: heroScan, alt: 'Rivelin contact hero visual.' },
      },
      sections: [],
    },
    requestDemo: {
      path: '/request-demo',
      seo: {
        title: 'Book a demo',
        description:
          'Request a Rivelin Robotics demo through a low-friction form designed for serious manufacturing enquiries.',
      },
      hero: {
        eyebrow: 'Book a demo',
        title: 'Book a demo',
        body: 'Share the part family or production question.',
        primaryAction: { label: 'View products', href: '/products' },
        secondaryAction: { label: 'Contact the team', href: '/contact' },
        media: { type: 'image', src: robotCloseup, alt: 'Request demo visual showing finishing hardware close-up.' },
      },
      sections: [],
    },
    privacyPolicy: {
      path: '/privacy-policy',
      seo: {
        title: 'Privacy policy',
        description: 'Privacy policy for the Rivelin Robotics website and lead capture workflows.',
      },
      hero: {
        eyebrow: 'Legal',
        title: 'Privacy policy',
        body: 'How site data is handled.',
        primaryAction: { label: 'Contact Rivelin', href: '/contact' },
        secondaryAction: { label: 'Return home', href: '/' },
        media: { type: 'image', src: heroScan, alt: 'Privacy policy visual.' },
      },
      sections: [
        {
          type: 'policy',
          items: [
            {
              title: 'Introduction',
              body: 'Rivelin Robotics collects only the information needed to respond to enquiries, evaluate applications, and maintain the website experience responsibly.',
            },
            {
              title: 'Legal basis for processing',
              body: 'Processing may rely on consent, legitimate interest, contractual necessity, or legal compliance depending on the nature of the interaction.',
            },
            {
              title: 'How data is used',
              body: 'Data submitted through website forms is used to route enquiries, coordinate follow-up, and maintain a record of relevant business conversations.',
            },
            {
              title: 'Retention',
              body: 'Personal data is retained only for as long as reasonably necessary to satisfy the original purpose, meet legal obligations, or manage disputes.',
            },
            {
              title: 'Your rights',
              body: 'You may ask to access, update, or remove your personal information by contacting the company directly at info@rivelinrobotics.com.',
            },
          ],
        },
      ],
    },
  },
};

export default fallbackSiteContent;
